import React from "react";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import {withTranslation} from 'react-i18next';

const DeleteConfirmDialog = ({isOpen, handleClose, handleContinue, t, i18n}) => {
    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{t('action_confirm')}</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1">
                            {
                                i18n.language === "en"
                                    ? 'Are you sure you want to delete the document? ' +
                                    'If this document was uploaded in other subsections, it will also be deleted.'
                                    : 'Вы уверены, что хотите удалить документ? ' +
                                    'Если данный документ был загружен в других подразделах, то он также будет удален.'
                            }
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    {t('cancel')}
                </Button>
                <Button onClick={handleContinue} color="primary" autoFocus>
                    {t('delete')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default withTranslation()(DeleteConfirmDialog);
